export const IMAGE_UPLOAD_REQUEST = "IMAGES/IMAGE_UPLOAD_REQUEST";
export const IMAGE_UPLOAD_COMPLETED = "IMAGES/UPLOADS_COMPLETE";
export const IMAGE_UPLOAD_STATUS_UPLOADING = "IMAGES/UPLOADING";
export const IMAGE_UPLOAD_STATUS_UPLOADED = "IMAGES/UPLOADED";
export const IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD = "IMAGES/WAITING_FOR_UPLOAD";
export const IMAGE_UPLOAD_STATUS_FAILED = "IMAGES/FAILED";



// WEBPACK FOOTER //
// ./src/shared/redux/constants/index.js